import createPalette from '@mui/material/styles/createPalette';

const rawPalette = createPalette({});

import colors from './colors';

const palette = {
  mode: 'light' as const,
  common: {
    white: colors.basic.white,
    black: colors.basic.black,
  },
  primary: {
    light: colors.brandPrimary[400],
    main: colors.brandPrimary[500],
    dark: colors.brandPrimary[700],
  },
  secondary: {
    light: colors.brandSecondary[400],
    main: colors.brandSecondary[500],
    dark: colors.brandSecondary[700],
  },
  error: {
    light: colors.error[400],
    main: colors.error[500],
    dark: colors.error[700],
  },
  warning: {
    light: colors.warning[400],
    main: colors.warning[500],
    dark: colors.warning[800],
    contrastText: colors.transparentGray[900],
  },
  success: {
    light: colors.success[400],
    main: colors.success[500],
    dark: colors.success[800],
    contrastText: colors.transparentGray[900],
  },
  /**
   * Also known as 'price' in the O2 palette.
   */
  info: {
    light: colors.price[400],
    main: colors.price[500],
    dark: colors.price[600],
  },
  /*
   as we're adding a new color, we have to introduce it a little differently ¯\_(ツ)_/¯
   (otherwise contrastText isn't auto-set, and it crashes anything that renders e.g. an internal Chip)
   tracked in: https://github.com/mui/material-ui/issues/29730
   idea from: https://github.com/mui/material-ui/issues/12390#issuecomment-410061712
   doc reference: https://mui.com/material-ui/customization/palette/#providing-the-colors-directly
   */
  internal: rawPalette.augmentColor({
    color: {
      light: colors.internal[100],
      main: colors.internal[500],
      dark: colors.internal[600],
    },
  }),
  neutral: rawPalette.augmentColor({
    color: {
      light: colors.transparentGray[300],
      main: colors.transparentGray[500],
      dark: colors.transparentGray[700],
    },
  }),
  background: {
    default: colors.basic[200],
    primary: colors.brandPrimary[100],
    internal: colors.internal[100],
    internalDark: colors.internal[200],
    grayTransparent: colors.transparentGray[400],
    warning: colors.warning[100],
    success: colors.success[100],
    error: colors.error[100],
    // @deprecated
    preProd: colors.success[800],
    darkGray: colors.basic[300],
    info: colors.brandPrimary[100],
    white: colors.basic.white,
  },
  text: {
    primary: colors.transparentGray[900],
    secondary: colors.transparentGray[600],
    error: colors.error[700],
    disabled: colors.transparentGray[400],
  },
  divider: colors.solidGray[200],
  backdrop: colors.transparentGray[400],
  action: {
    hoverOpacity: 0.04,
    selectedOpacity: 0.1,
  },
};

export default palette;
